import { createFileRoute } from '@tanstack/react-router'
import TermsRulesReportList from 'Royalty/components/Test/tabs/TermsRulesReportList'

export const Route = createFileRoute('/royalty/reports/terms')({
    component: TermsRulesReportList,
})
